import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import EmailAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/email/email.entity";
import { ICreateBusinessPartnerEmail } from "app/modules/components/business-partners/business-partner/business-partner-email-modal/interfaces/create-business-partner-email.interface";
import { IUpdateBusinessPartnerEmail } from "app/modules/components/business-partners/business-partner/business-partner-email-modal/interfaces/update-business-partner-email.interface";
const apiUrl = env.API_CONFIGURATION_URL;
const moduleName = "company_contact_email";

@Injectable({
  providedIn: "root",
})
export class CompanyContactEmailService extends AbstractService<
EmailAttributes,
ICreateBusinessPartnerEmail,
IUpdateBusinessPartnerEmail
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByCompanyId(companyId: string): Observable<IResult<EmailAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${companyId}`;
    return this.http.get<IResult<EmailAttributes>>(API_URL);
  }
}